import { buildListingResultViewModel } from '../../../view-models/listing-result.viewmodel.js';

const TITLE_STRATEGY_LABELS = [
  'SEO 平衡型',
  '点击率强化型',
  '品牌表达型',
];

function createElement(tagName, className, text) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== undefined && text !== null) element.textContent = text;
  return element;
}

function createMetric(label, value, hint = '') {
  const metric = createElement('div', 'listing-review-metric');
  metric.append(
    createElement('span', 'listing-review-metric-label', label),
    createElement('strong', 'listing-review-metric-value', value),
  );
  if (hint) metric.append(createElement('span', 'listing-review-metric-hint', hint));
  return metric;
}

function createTitleCard(option, index, selectedIndex) {
  const isSelected = index === selectedIndex;
  const label = TITLE_STRATEGY_LABELS[index] || `策略 ${index + 1}`;
  const badges = [];
  if (option.charCount) badges.push(`${option.charCount} 字符`);
  if (Array.isArray(option.tags) && option.tags.length) badges.push(...option.tags.slice(0, 2));
  if (option.formula) badges.push(option.formula);

  const card = createElement('article', `listing-review-title-card${isSelected ? ' is-selected' : ''}`);
  const head = createElement('div', 'listing-review-title-head');
  head.append(
    createElement('span', 'listing-review-title-label', `版本 ${option.version || String.fromCharCode(65 + index)}`),
    createElement('span', 'listing-review-title-strategy', label),
  );
  const meta = createElement('div', 'listing-review-title-meta');
  meta.append(...badges.map((badge) => createElement('span', 'listing-review-title-badge', badge)));
  const footer = createElement('div', 'listing-review-title-footer');
  footer.append(createElement('span', isSelected ? 'listing-review-current' : 'listing-review-available', isSelected ? '当前使用' : '可切换'));
  if (isSelected) footer.append(createElement('span', 'listing-review-check', '✓'));
  card.append(head, createElement('div', 'listing-review-title-text', option.text || '暂无'), meta, footer);
  return card;
}

function createReviewHeading({ empty = false } = {}) {
  const copy = createElement('div');
  copy.append(
    createElement('div', 'listing-review-kicker', 'Step 03 · Listing 生成结果'),
    createElement('h3', 'listing-review-title', empty ? '先生成 Listing，再进入诊断中心' : '这版 Listing 可以保存了吗？'),
    createElement('p', 'listing-review-copy', empty
      ? '这里会展示标题策略、合规预览、Search Terms 字节和内容摘要，帮助你快速判断这一版能不能直接保存。'
      : '先看标题策略和生成质量，再决定是否进入诊断中心继续优化。'),
  );
  return copy;
}

export function createListingReviewStrip(input = {}) {
  const model = buildListingResultViewModel(input);
  if (!model.hasContent) {
    const strip = createElement('div', 'listing-review-strip listing-review-strip-empty');
    const actions = createElement('div', 'listing-review-actions');
    const button = createElement('button', 'ghost-button', '进入诊断');
    button.id = 'step3-open-diagnostic-button';
    button.type = 'button';
    button.disabled = true;
    actions.append(button);
    strip.append(createReviewHeading({ empty: true }), actions);
    return strip;
  }

  const titleOptions = model.title.options || [];
  const selectedIndex = model.title.selectedIndex || 0;
  const titleCount = titleOptions.length || (model.title.primaryText ? 1 : 0);
  const bulletCount = model.bullets.count || 0;
  const qaCount = model.qa.count || 0;
  const aplusCount = model.aplusModules.length || 0;
  const searchTerms = model.searchTerms;
  const healthTone = model.canProceedToFullTextReview ? 'is-good' : 'is-warning';

  const strip = createElement('section', `listing-review-strip ${healthTone}`);
  const head = createElement('div', 'listing-review-strip-head');
  const actions = createElement('div', 'listing-review-actions');
  const button = createElement('button', 'ghost-button', '进入诊断');
  button.id = 'step3-open-diagnostic-button';
  button.type = 'button';
  button.disabled = !model.canProceedToFullTextReview;
  actions.append(button, createElement('span', `listing-review-status ${model.canProceedToFullTextReview ? 'is-ready' : 'is-pending'}`, model.statusLabel));
  head.append(createReviewHeading(), actions);

  const metrics = createElement('div', 'listing-review-metrics');
  metrics.append(
    createMetric('标题策略', `${titleCount} 版`, model.title.selectedVersionLabel || '默认选中当前版本'),
    createMetric('五点', String(bulletCount), bulletCount >= 5 ? '内容完整' : '还需补齐'),
    createMetric('Search Terms', `${searchTerms.byteCount} / ${searchTerms.byteLimit} bytes`, searchTerms.isOverLimit ? '超限' : '合规'),
    createMetric('QA / A+', `${qaCount} / ${aplusCount}`, qaCount || aplusCount ? '可继续完善' : '可先进入诊断'),
  );
  strip.append(head, metrics);
  if (titleOptions.length) {
    const grid = createElement('div', 'listing-review-title-grid');
    grid.append(...titleOptions.slice(0, 3).map((option, index) => createTitleCard(option, index, selectedIndex)));
    strip.append(grid);
  }
  return strip;
}

export function renderListingReviewStripInto(container, input = {}) {
  if (!container) return;
  container.replaceChildren(createListingReviewStrip(input));
}
